// src/auth/RequireAdmin.jsx
import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./useAuth";

/**
 * Protège des routes réservées aux admins.
 * Accepte is_admin, is_superuser, ou role in {"admin","superuser","owner"}.
 */
export default function RequireAdmin() {
  const { user } = useAuth();
  const location = useLocation();

  const isAdmin =
    !!user &&
    (user.is_admin === true ||
     user.is_superuser === true ||
     ["admin", "superuser", "owner", "super_admin"].includes(user.role));

  if (!user) {
    // pas connecté: renvoie vers /login
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (!isAdmin) {
    // connecté mais non admin: renvoie vers le tableau de bord
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
